<template>
  <div class="component-page4">
    <img src="./page4.jpg" style="width: 100%" alt="">
  </div>
</template>

<script>
export default {
  name: "page4",
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  filters: {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.component-page4 {

}
</style>
<style lang="scss">
.component-page4_body { //dialog使用 customClass="xxx_body"

}
</style>
